import Truncate from 'react-truncate';

import { Markdown } from '@common/components';

import { GuestCounter } from '@common/components/GuestPicker/GuestCounter';
import { useTranslations } from '@lang';
import Alert from '@common/components/Alert/Alert';
import { PopperRow } from '@common/components/Popper';
import { ClockIcon, PeopleIcon } from '@root/styles/icons';
import { isMobile } from '@utils/grid';

import {
  GuestCounterWrapper,
  ShowMoreLess,
  SpaClassesDetailsContainer,
  SpaDetails,
  SpaDetailsClasses,
  SpaDetailsHeadSection,
  SpaDetailsWrapper,
  SpaItemName,
} from './ExperienceDetails.styles';
import { useState } from 'react';
import { ExperienceDetailsProps } from './ExperienceDetails';

export const ExperienceDetailsClasses = ({
  id,
  count,
  plusMinusSpaOption,
  disabledMinus,
  disabledPlus,
  allOptionsIncluded,
  unavailable,
  optionId,
  spaEntity,
}: ExperienceDetailsProps) => {
  const { t } = useTranslations();
  const [isDescriptionExpanded, setIsDescriptionExpanded] = useState(false);
  function toggleShowMore() {
    setIsDescriptionExpanded((val) => !val);
  }

  const unavailableText = t('common.unavailable');

  const spaSummaryMaxLength = 322;
  const spaSummary = spaEntity?.description || '';
  const spaSummaryLongerThanMax = spaSummary.length > spaSummaryMaxLength;

  return (
    <>
      {spaEntity && (
        <SpaDetailsWrapper>
          <SpaDetailsHeadSection>
            <SpaItemName>{spaEntity?.name}</SpaItemName>
            <GuestCounterWrapper>
              {unavailable && (
                <PopperRow>
                  <Alert content={unavailableText} />
                </PopperRow>
              )}
              {!unavailable && !allOptionsIncluded ? (
                <GuestCounter
                  count={count}
                  onClickMinus={() =>
                    plusMinusSpaOption('minus', Number(id), Number(optionId), spaEntity?.startTime)
                  }
                  disabledMinus={disabledMinus}
                  disabledPlus={disabledPlus}
                  onClickPlus={() =>
                    plusMinusSpaOption('plus', Number(id), Number(optionId), spaEntity?.startTime)
                  }
                  label="Guests"
                />
              ) : (
                <div />
              )}
            </GuestCounterWrapper>
            <SpaClassesDetailsContainer>
              {spaEntity.timeslots?.map((timeslot) => (
                <SpaDetailsClasses>
                  <ClockIcon />
                  {timeslot.startTime.slice(0, 5)} &#x2022;{' '}
                  {t('spa.minutesIndicator', { number: timeslot.durationMinutes })}
                  <PeopleIcon />
                  {isMobile() ? <span>&#x2022;</span> : <></>}
                  {t('spaClasses.spaces', { number: timeslot.quantity })}
                </SpaDetailsClasses>
              ))}
            </SpaClassesDetailsContainer>
          </SpaDetailsHeadSection>

          {!isMobile && (
            <>
              <SpaDetails>
                {isDescriptionExpanded ? (
                  <Markdown text={spaEntity.description} />
                ) : (
                  <Truncate trimWhitespace lines={6}>
                    <Markdown text={spaEntity.description} />
                  </Truncate>
                )}
              </SpaDetails>
              {spaSummaryLongerThanMax && (
                <ShowMoreLess onClick={toggleShowMore}>
                  {isDescriptionExpanded ? t('common.readLess') : t('common.readMore')}
                </ShowMoreLess>
              )}
            </>
          )}
        </SpaDetailsWrapper>
      )}
    </>
  );
};
